module.exports = __webpack_public_path__ + "img/scan.ee97273a.svg";